import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = []

  connect() {
    this.input()
  }

  input() {
    if (!this.msieversion()) {
      this.element.style.background =
        'linear-gradient(to right, #14B2F9 0%, #7585FA ' +
        this.element.value +
        '%, ' +
        this.data.get('bg-color') +
        ' ' +
        this.element.value +
        '%, ' +
        this.data.get('bg-color') +
        ' 100%)'
    }
  }

  msieversion() {
    var ua = window.navigator.userAgent
    var msie = ua.indexOf('MSIE ')

    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
      // If Internet Explorer, return version number
      return true
    } else {
      return false
    }
  }
}
